import type { ReactNode } from "react";
import { Trash2 } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/app/admin/_common/ui/dialog";
import CuoButton from "@/app/admin/_common/CuoButton";

/** Destructive confirm. Not CuoConfirmDialog: that one is still MUI. */
export default function ConfirmDialog({
  open,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = "Remove",
  icon = <Trash2 className="size-4 flex-none text-muted-foreground" />,
}: {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText?: string;
  icon?: ReactNode;
}) {
  return (
    <Dialog open={open} onOpenChange={(next) => !next && onClose()}>
      <DialogContent className="inset-0 left-0 top-0 m-auto h-fit w-full max-w-[420px] translate-x-0 translate-y-0 bg-white">
        <DialogHeader>
          <DialogTitle>
            <span className="inline-flex items-center gap-2 align-middle">
              {icon}
              {title}
            </span>
          </DialogTitle>
          <DialogDescription>{message}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <CuoButton variant="outline" label="Cancel" onClick={onClose} />
          <CuoButton
            variant="destructive"
            label={confirmText}
            onClick={() => {
              onConfirm();
              onClose();
            }}
          />
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
